import { NgModule } from '@angular/core';
import {
  HasPermissionsPipe,
  HasRolePipe,
  HasSomePermissionPipe,
  IsOwnerPipe,
} from './has-permissions.pipe';

@NgModule({
  imports: [HasPermissionsPipe, HasSomePermissionPipe, HasRolePipe, IsOwnerPipe],
  exports: [HasPermissionsPipe, HasSomePermissionPipe, HasRolePipe, IsOwnerPipe],
})
export class PermissionsModule {}
